import { FormControl } from '@angular/forms';
import { DocumentMetadata } from '@core-lib/modules';
import { IList } from './list.model';
import { IModeleData } from './referentials.model';

export interface IModeleDocumentLight {
	id?: string;
	libelle: string;
	nom?: string;
	documentMetadata?: DocumentMetadata;
	isDefault?: boolean;
}

export interface IModeleDocument extends IModeleDocumentLight {
	isActif?: boolean;
	dateCreation?: Date;
	dateModification?: Date;
	modeleDataId: string;
	modeleData?: any;
	utilisateurModification?: string;
	utilisateurModificationId?: string;
	carpaId?: string;
}

export interface ICommonSettingsModeleDocument {
	id?: string;
	nom?: string;
	isActif?: boolean;
	libelle: string;
	isDefault?: boolean;
	modeleDataId: string;
	document: any;
	documentMetadata?: {
		documentId: string;
		name: string;
		tenantKey: string;
		modeleDocumentId: string;
		utilisateur: string;
	};
	modeleData: IModeleData;
}

export interface ICourrierViewmodel {
	modeles: IModeleDocumentLight;
}

export interface ICourrier {
	id: string;
	nom: string;
	affaireId: string;
	numAffaire: number;
	nomAffaire: string;
	dateCreation: Date;
	dateReponse: Date;
	dateRelance: Date;
	dateCloture: Date;
	type: string;
	statut: string;
	creePar: string;
	commentaires: string;
	envoyeParMail: boolean;
	documentMetadata: DocumentMetadata[];
}

export interface ICourrierList extends IList<ICourrier> {}

export interface ISuiviCourriersfiltre {
	compteId: string;
	nom: string;
	codes: string[];
	exclureDocs?: boolean;
}

export interface ISuiviCourriersfiltreForm {
	compteId: FormControl<string>;
	nom: FormControl<string>;
	codes: FormControl<string[]>;
}

export enum SuiviCourriersSortableCols {
	nom = 'nom',
	numeroAffaire = 'numeroAffaire',
	nomAffaire = 'nomAffaire',
	dateCreation = 'dateCreation',
	dateReponse = 'dateReponse',
	dateRelance = 'dateRelance',
	dateCloture = 'dateCloture',
	type = 'type',
	statut = 'statut',
	creePar = 'creePar',
	commentaires = 'commentaires',
	envoyeParMail = 'envoyeParMail'
}
